import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

/*
 * https://lobotuerto.com/thingies/vuetify-color-theme-builder/
 */
Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    defaultTheme: "light",
  },
  old_theme: {
    primary: "#1976D2",
    secondary: "#424242",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
});
